<template>
  <div class="main-container"><slot></slot></div>
</template>

<script>
export default {
  name: "container"
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/vars";
@import "../../assets/styles/mixins";

.clearfix {
  @include clearfix;
}

.main-container {
  max-width: 1550px;
  position: relative;
  padding: 0 50px;
  margin: 0 auto;

  @media (max-width: $screen-sm-max) {
    padding: 0 13px;
  }

  @media (max-width: $screen-xs) {
    padding: 0 10px;
  }
}
</style>
